import { useEffect, useState } from "react";
import { GREEN_MEBI_LOGO_SMALL_CIRCLE_SRC } from "@mebi/ui";
import LoadingSpinner from "@/components/ui/LoadingSpinner";

interface SplashScreenProps {
  onFinish?: () => void;
  duration?: number;
}

const SplashScreen = ({ onFinish, duration = 2000 }: SplashScreenProps) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onFinish) {
        setTimeout(onFinish, 300); // Wait for fade out animation
      }
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onFinish]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-Color-Background-neutral-default_primary transition-opacity duration-300">
      <div className="flex flex-col items-center justify-center gap-6">
        <div className="flex items-center justify-center w-full">
          <img
            src={GREEN_MEBI_LOGO_SMALL_CIRCLE_SRC}
            alt="Mebi"
            className="h-32 w-32 object-contain sm:h-40 sm:w-40 xl:h-48 xl:w-48"
          />
        </div>
        <div className="text-center">
          <h1 className="text-2xl font-bold text-Color-Text-neutral-black leading-8">
            Hành trình ghi dấu đam mê
            <br />
            của bạn
          </h1>
        </div>
      </div>
      <div className="absolute bottom-20">
        <LoadingSpinner size="md" showBackground={false} text="" />
      </div>
    </div>
  );
};

export default SplashScreen;
